angular.module('dnecom')
    .service('SizeProfileUtils', function () {
        var that = this;
        this.defaultColumnsCount = 2;
        this.defaultColumnNames = ['A', 'B', 'C'];
        this.defaultSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];

        this.createNode = function (columnName, value) {
            value = value || {cm: '', inch: ''};
            return {column: columnName, value: value};
        };

        this.create = function () {
            var sizes = [];
            this.defaultSizes.forEach(function(size){
                var values = [];
                for (var i = 0; i < that.defaultColumnsCount; i++) {
                    values.push(that.createNode(that.defaultColumnNames[i]));
                }
                sizes.push({
                    name: size,
                    values: values
                });
            });

            return {
                sizes: sizes,
                properties: {
                    closeButtonTitle: 'Close'
                }
            };
        };

        this.adjustColumns = function (sizeProfile, expectedLength) {
            var actualLength = this.getProfileColumns(sizeProfile).length;
            if (actualLength > expectedLength) {
                this.removeColumns(sizeProfile, actualLength - expectedLength);
            }

            if (actualLength < expectedLength) {
                this.addColumns(sizeProfile, expectedLength - actualLength);
            }
        };

        this.removeColumns = function (sizeProfile, remove) {
            sizeProfile.sizes.forEach(function(row) {
                var end = row.values.length - remove;
                row.values = row.values.slice(0, end);
            });
        };

        this.addColumns = function (sizeProfile, add) {
            var actualLength = this.getProfileColumns(sizeProfile).length;
            sizeProfile.sizes.forEach(function(row) {
                for (var i = 0; i < add; i++) {
                    var idx = actualLength + i;
                    row.values.push(that.createNode(that.defaultColumnNames[idx]));
                }
            });
        };

        this.getProfileColumns = function (sizeProfile) {
            var columnNames = [];
            if (typeof sizeProfile.sizes[0] == "object") {
                sizeProfile.sizes[0].values.forEach(function(value){
                    columnNames.push(value.column);
                });
            }

            return columnNames;
        };

        this.getProfileSizes = function (sizeProfile) {
            var sizes = [];
            sizeProfile.sizes.forEach(function(size){
                sizes.push(size.name);
            });

            return sizes;
        };

        this.updateColumnName = function (sizeProfile, newValue, index) {
            sizeProfile.sizes.forEach(function(row) {
                if (typeof row.values[index] != "undefined") {
                    row.values[index].column = newValue;
                }
            });
        };

        this.fromInchToCm = function (value) {
            return parseFloat((2.54 * value).toFixed(2));
        };

        this.fromCmToInch = function (value) {
            return parseFloat((value / 2.54).toFixed(2));
        };
    });

